import Vue from 'vue'
import Router from 'vue-router'
import Heating from '@/pages/heatingCharge'
import chargeDetail from '@/pages/chargeDetail'
import HouseProperty from '@/pages/HouseProperty'
import serviceAgreement from '@/pages/serviceAgreement'
import addHouseProperty from '@/pages/addHouseProperty'
import qrCode from  '@/pages/qrCode'
import myInformation from '@/pages/myInformation'
import updatePhone from '@/pages/updatePhone'
import sureCharge from '@/pages/sureCharge'
import chargeSuccess from '@/pages/chargeSuccess'
import myCharge from '@/pages/myCharge'
import updateAgreement from '@/pages/updateAgreement'
import check from '@/pages/check'
import Abnormal from '@/pages/Abnormal'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/heatingcharge/mobile',
  routes: [
    {
      path: '/check',
      name: 'check',
      component: check
    },
    {
      path: '/heating-charge',
      name: 'heating-charge',
      component: Heating,
      meta: {
        title: '缴费查询',
        requireAuth: true
      }
    },
    {
      path: '/charge-detail',
      name: 'chargeDetail',
      component: chargeDetail,
      meta:{
        title:'缴费详情',
        requireAuth:true
      }
    },
    {
      path: '/house-property',
      name: 'houseProperty',
      component: HouseProperty,
      meta:{
        title:'名下房产',
        requireAuth:true
      }
    },
    {
      path: '/service-agreement',
      name: 'serviceAgreement',
      component: serviceAgreement,
      meta:{
        title:'用户服务协议',
        requireAuth:true
      }
    },
    {
      path: '/add-house-property',
      name: 'addHouseProperty',
      component:addHouseProperty,
      meta:{
        title:'添加房产',
        requireAuth:true
      }
    },
    {
      path: '/qr-code',
      name: 'qrCode',
      component: qrCode,
      meta:{
        title:'房产信息',
        requireAuth:true
      }
    },
    {
      path: '/my-information',
      name: 'myInformation',
      component: myInformation,
      meta:{
        title:'我的信息',
        requireAuth:true
      }
    },
    {
      path: '/update-phone',
      name: 'updatePhone',
      component: updatePhone,
      meta:{
        title:'电话注册',
        requireAuth:true
      }
    },
    {
      path: '/sure-charge',
      name: 'sureCharge',
      component: sureCharge,
      meta:{
        title:'确认缴费',
        requireAuth:true
      }
    },
    {
      path: '/charge-success',
      name: 'chargeSuccess',
      component: chargeSuccess,
      meta:{
        title:'缴费成功',
        requireAuth:true
      }
    },
    {
      path: '/my-Charge',
      name: 'myCharge',
      component: myCharge,
      meta:{
        title:'我的缴费',
        requireAuth:true
      }
    },
    {
      path: '/update-Agreement',
      name: 'updateAgreement',
      component: updateAgreement,
      meta:{
        title:'企业服务免责协议',
        requireAuth:true
      }
    },
    {
      path: '*',
      name: 'Abnormal',
      component: Abnormal,
      meta:{
        title:'系统维护',
        requireAuth:true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js